import { render, staticRenderFns } from "./i-wrapper.vue?vue&type=template&id=55eef324&scoped=true&"
import script from "./i-wrapper.vue?vue&type=script&lang=js&"
export * from "./i-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./i-wrapper.vue?vue&type=style&index=0&id=55eef324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eef324",
  null
  
)

export default component.exports